import { Component, EventEmitter, NgModule, OnInit, Output} from '@angular/core';
import { StageService } from '../formation/stage-modal/stage-onglet/services/stage-modal.service';
import { BObjectModel, BreadDik, QueovalParam } from '../models';
import { InfoAdresse } from '../models/formation/formation.model';
import { CoreService, HttpService } from '../services';
@Component({
  selector: 'queoval-lieu',
  templateUrl: './lieu.component.html',
  styleUrls: ['./lieu.component.css']
})

/*
* Composant pour l'affichage du lieu
*/
export class LieuComponent implements OnInit {

  // #region CONSTRUCTEUR

  constructor(
    public service: StageService,
    private http: HttpService,
    private core: CoreService
  ) { }

  // #endregion

  // #region VARIABLES GLOBALES

  /** model qui stock les infos de l'adresse à l'init */
  public adresseInfos: InfoAdresse;

  /**
   * Pour savoir si on est en mode édition d'adresse
   */
  public IsEditLocation: boolean;

  /**
   * Pour savoir si les données sont chargées (et éviter d'ouvrir trop tôt la modification)
   */
  public IsLoaded: boolean = false;

  public showBo: boolean = true;

  public paramBO: QueovalParam = new QueovalParam();

  public idLocationConvocationSelected: string;
  public idClientSelected: string;
  @Output() AdresseLieu: EventEmitter<string> = new EventEmitter<string>();

  // #endregion

  // #region CYCLE DE VIE

  public ngOnInit(): void {

    this.adresseInfos = new InfoAdresse();
    this.IsEditLocation = false;
    this.InitData();

  }
  // #endregion

  // #region FONCTIONS PUBLIQUES

  public OpenEditLocation(): void {
    // Réinitialisation de l'adresse pour récupérer les infos à jour
    this.InitData();
    this.IsEditLocation = true;
  }

  public CloseEditLocation(): void {
    this.IsEditLocation = false;
    this.paramBO.params = [];
    // Réinitialisation de l'adresse pour récupérer les infos à jour
    this.InitData();
  }

  /**
   * Récupération des champs "adresse" du client
   * @param idClient
   */
  public GetClientLocation(idClient: string): void {
    this.idClientSelected = idClient;
    this.http.getHttp<InfoAdresse>(`${this.core.AppParams.apiUrl}api/lieux/getData/FILL_CLIENT_ADRESS/${idClient}`)
      .subscribe((result: InfoAdresse) => {
        if (!result.HasError) {
          this.paramBO.params = [];
          this.paramBO.model.DefaultInputs = result.ListInputAdressClient;
          this.paramBO = JSON.parse(JSON.stringify(this.paramBO));
        }
      });
  }

  /**
  * Récupération de l'adresse de convocation
  * @param idClient
  */
  public GetConvocationLocation(idAdresse: string): void {
    this.showBo = false;
    this.idLocationConvocationSelected = idAdresse;
    this.http.getHttp<InfoAdresse>(`${this.core.AppParams.apiUrl}api/lieux/getData/GET_BO_LIEU_CONVOCATION/${idAdresse}|${this.service.Stage.Ident}`)
      .subscribe((result: InfoAdresse) => {
        if (!result.HasError) {
          this.paramBO.params = idAdresse == '0' ? [] : [new BreadDik('isLoaded', true)];
          this.paramBO.model = result.BoLieuConvocation;
          this.paramBO = JSON.parse(JSON.stringify(this.paramBO));
          this.showBo = true;
        }
      });
  }

  // #endregion

  // #region FONCTIONS PRIVES

  /**
   *  charge les infos du lieu à afficher en fonction du stage selectionné
   */
  private InitData() {
    this.http.getHttp<InfoAdresse>(`${this.core.AppParams.apiUrl}api/lieux/getData/INIT_ADRESSE/${this.service.Stage.Ident}`)
      .subscribe((result: InfoAdresse) => {
        if (!result.HasError) {
          this.adresseInfos = result;
          this.paramBO.model = result.ModelBO;
          this.IsLoaded = true;
          result.Adresse1 = result.Adresse1 == null ? '' : result.Adresse1;
          result.Adresse2 = result.Adresse2 == null ? '' : result.Adresse2;
          result.VilleAdress = result.VilleAdress == null ? '' : result.VilleAdress;
          this.AdresseLieu.emit(`${result.Adresse1} ${result.Adresse2} ${result.VilleAdress}`);          
        }
      });
  }
  // #endregion
}
